<template>
  <div
    class="border-l-4 p-4"
    :class="getBoxClass"
  >
    <div class="flex items-center justify-start">
      <div class="shrink-0">
        <fa
          v-if="icon.length > 0"
          :icon="icon"
          class="text-xl fa-fw"
          :class="getIconClass"
        />
      </div>
      <div class="ml-3">
        <p
          class="text-sm leading-5"
          :class="getTextClass"
        >
          <slot />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterNotice',

  props: {
    icon: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: 'blue',
    },
  },

  computed: {
    getTextClass() {
      switch (this.color) {
        case 'red':
          return 'text-red-700';
        case 'orange':
          return 'text-orange-700';
        case 'indigo':
          return 'text-indigo-700';
        case 'pink':
          return 'text-pink-700';
        case 'green':
          return 'text-green-700';
        case 'blue':
        default:
          return 'text-blue-700';
      }
    },
    getIconClass() {
      switch (this.color) {
        case 'red':
          return 'text-red-400';
        case 'orange':
          return 'text-orange-400';
        case 'indigo':
          return 'text-indigo-400';
        case 'pink':
          return 'text-bubblegum';
        case 'green':
          return 'text-green-400';
        case 'blue':
        default:
          return 'text-blue-400';
      }
    },
    getBoxClass() {
      switch (this.color) {
        case 'red':
          return 'bg-red-50 border-red-400';
        case 'orange':
          return 'bg-orange-50 border-orange-400';
        case 'indigo':
          return 'bg-indigo-50 border-indigo-400';
        case 'pink':
          return 'bg-pink-50 border-pink-400';
        case 'green':
          return 'bg-green-50 border-green-400';
        case 'blue':
        default:
          return 'bg-blue-50 border-blue-400';
      }
    },
  },
};
</script>
